import { ChatgptMediaType } from "@redotech/crdb-enums/product/chatgpt-media-type";
import { imageIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ChatGptMediaContentTypeSchema = createEnum(ChatgptMediaType);

const ChatGptListingMediaSchema_ = z.object({
  url: z.string(),
  contentType: ChatGptMediaContentTypeSchema,
  imageId: imageIdFormat.schema.nullish(),
});
export const ChatGptListingMediaSchema: z.ZodType<ChatGptListingMedia> =
  ChatGptListingMediaSchema_;
export interface ChatGptListingMedia extends z.infer<
  typeof ChatGptListingMediaSchema_
> {}
